"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/Skeleton.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







// What a settings section looks like while it loads (F-4): shimmering
// lines where the content will be, instead of a blank area or a spinner.
const SettingsSkeleton = ({ lines = 4, label = 'Loading' }) => (
  _react2.default.createElement('div', { className: "settings--skeleton", role: "status", 'aria-label': label, 'aria-busy': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
    , _react2.default.createElement('span', { className: "settings--skeleton--line settings--skeleton--line-title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}} )
    ,  Array.from({ length: lines }, (_, i) => _react2.default.createElement('span', { key: i, className: "settings--skeleton--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}} )) 
  )
)

exports. default = SettingsSkeleton
